namespace app.autenticacao {
    "use strict";

    declare const ineum;

    export class InstanaService {

        private registeredUserLogin: string;
        
        /** @ngInject **/
        constructor() {
        }

        registerUser(user: IUser): void {
            if (this.registeredUserLogin !== user.login) {
                if (this.isInstanaEUMDefined()) {
                    ineum('user', user.login, user.nome, user.email);
                }
                this.registeredUserLogin = user.login;
            }
        }

        unregisterUser(): void {
            if (this.registeredUserLogin) {
                if (this.isInstanaEUMDefined()) {
                    ineum('user', null, null, null);
                }
                this.registeredUserLogin = null;
            }
        }

        private isInstanaEUMDefined(): boolean {
            return typeof ineum !== 'undefined';
        }

    }

    angular
        .module("app.autenticacao")
        .service("instanaService", InstanaService);
}